module.exports = __webpack_public_path__ + "static/media/logo-white.9a3d9319.png";